import { PageHero } from "@/components/common/PageHero";
import { Reveal } from "@/components/common/Reveal";
import { EnquiryForm } from "@/components/common/EnquiryForm";
import { CheckCircle2 } from "lucide-react";
import { Seo } from "@/components/common/Seo";
import { PAGES, IMAGES, SEO } from "@/content/site";

const BENEFITS = [
  "A Dubai-based partner focused on provenance and documentation",
  "Structured engagement with qualified business demand",
  "Long-term relationships over one-off transactions",
  "Clear, structured onboarding — no document uploads required at this stage",
];

export default function ForSuppliers() {
  const p = PAGES.forSuppliers;
  return (
    <div data-testid="page-for-suppliers">
      <Seo title={SEO.forSuppliers.t} description={SEO.forSuppliers.d} path="/for-suppliers" />
      <PageHero eyebrow={p.eyebrow} title={p.title} lead={p.lead} image={IMAGES.freight} />
      <section className="container-x py-16 lg:py-24">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <Reveal>
              <h2 className="text-2xl font-semibold text-ink-heading">Why partner with Azeka</h2>
              <ul className="mt-6 space-y-4">
                {BENEFITS.map((b) => (
                  <li key={b} className="flex items-start gap-3">
                    <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-azeka-teal" />
                    <span className="text-sm text-ink-body">{b}</span>
                  </li>
                ))}
              </ul>
            </Reveal>
          </div>
          <Reveal delay={0.1} className="lg:col-span-7">
            <div className="rounded-2xl border border-slate-200/80 bg-white p-8 lg:p-10">
              <h3 className="text-lg font-semibold text-ink-heading">Supplier onboarding</h3>
              <p className="mt-2 text-sm text-ink-muted">Share your capabilities and our trade team will be in touch.</p>
              <div className="mt-6">
                <EnquiryForm defaultType="supplier" lockType includeSupplierFields />
              </div>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
